import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Logger } from '.';

// class to manage localStorage items
var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
  }
  _createClass(LocalStorage, null, [{
    key: "setItem",
    value:
    // takes in a key-value pair and sets it in localStorage. If the window is undefined, it throws an error
    function setItem(key, value) {
      try {
        if (typeof window === 'undefined') {
          throw new Error(LocalStorage.noWindowErrorMessage);
        }
        localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        Logger.error("Error while setting localStorage item :: ".concat(error));
      }
    }

    // accepts a key and then gets the key-value pair from localStorage if it exists else it returns null
  }, {
    key: "getItem",
    value: function getItem(key) {
      try {
        if (typeof window === 'undefined') {
          throw new Error(LocalStorage.noWindowErrorMessage);
        }
        var item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
      } catch (error) {
        Logger.error("Error while getting localStorage item :: ".concat(error));
        return null;
      }
    }

    // accepts a key and removes the key-value pair from localStorage
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      try {
        if (typeof window === 'undefined') {
          throw new Error(LocalStorage.noWindowErrorMessage);
        }
        localStorage.removeItem(key);
      } catch (error) {
        Logger.error("Error while removing localStorage item :: ".concat(error));
      }
    }

    // removes all key-value pairs from localStorage
  }, {
    key: "clear",
    value: function clear() {
      try {
        if (typeof window === 'undefined') {
          throw new Error(LocalStorage.noWindowErrorMessage);
        }
        localStorage.clear();
      } catch (error) {
        Logger.error("Error while clearing localStorage :: ".concat(error));
      }
    }
  }]);
  return LocalStorage;
}();
_defineProperty(LocalStorage, "noWindowErrorMessage", 'LocalStorage is not available in this environment.');
export default LocalStorage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/utils/localStorage.js
// module id = 1439
// module chunks = 11